import { render, staticRenderFns } from "./blankNoAuth.vue?vue&type=template&id=31fc339a&"
import script from "./blankNoAuth.vue?vue&type=script&lang=ts&"
export * from "./blankNoAuth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/home/ec2-user/environment/xsearch-app_62900_dev/src/components/Header.vue').default,Footer: require('/home/ec2-user/environment/xsearch-app_62900_dev/src/components/Footer.vue').default})
